export default "__VITE_ASSET__6bc4e655__"